import { SoaFrameworkPanel } from "../components/SoaFrameworkPanel";
import { StandardHeader, STANDARD_PAGE_LABELS } from "../components/standards/StandardHeader";

export function Iso42001SoaPage() {
  return (
    <div className="page-pad">
      <StandardHeader
        frameworkId="iso42001"
        page={STANDARD_PAGE_LABELS.soa}
        subtitle="Decide which AI management controls apply to your organisation, record why, and attach evidence."
      />
      <SoaFrameworkPanel frameworkId="iso42001" />
    </div>
  );
}
